module.exports = __webpack_public_path__ + "static/logo1-80ddf21ef630622df5a5b4924550a19d.svg";